module.exports = __webpack_public_path__ + "static/media/facebook_icon.21ed2f55.svg";